import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueResource from 'vue-resource'
import axios from 'axios'
import cookie from './util/cookie.js'
// import QRCode from 'qrcode';
import QRCode from 'qrcodejs2';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import moment from 'moment'
import 'amfe-flexible'
import rem from './util/rem.js'
import './assets/iconfont/iconfont.css'
Vue.use(ElementUI);

// Vue.prototype.HOST = 'http://localhost:8088'
Vue.prototype.HOST = 'http://internal.pisx.com:8012'
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
Vue.prototype.cookie = cookie;
Vue.prototype.$moment = moment;
Vue.use(Viewer, {
	defaultOptions: {
		zIndex: 9999,
		title: false, //    显示当前图片的标题
		scalable: false, //图片是否可翻转
		rotatable: false, //图片是否可旋转
		tooltip: false, //显示缩放百分比
		navbar: false, //显示缩略图导航
		loop: false,
		loading: false,
		fullscreen: false,
		toolbar: {
			zoomIn: 1,
			zoomOut: 1,
			reset: 1,
			rotateLeft: 1,
			rotateRight: 1,
			flipHorizontal: 1,
			flipVertical: 1,
		}
	}
})
router.afterEach((to, from, next) => {
	window.scrollTo(0, 0)
});
router.beforeEach((to, from, next) => {
	if (to.meta.needLogin == true) {
		if (cookie.getCookie("loginname")) {
			next()
		} else {
			if (to.path === "/login") {
				next()
			} else {
				next('/login')
			}
		}
	} else {
		next()
	}
});
new Vue({
	router,
	render: h => h(App),
}).$mount('#app')
